import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

// .env  ->  REACT_APP_HOTEL_REVIEW_API=https://api.hotel.namantechnolab.com/api/hotel/Review
const HOTEL_REVIEW_API = process.env.REACT_APP_HOTEL_REVIEW_API;
// .env  ->  REACT_APP_NAMO_TXN_API=https://promo.namantechnolab.com/api/Agent/NamoTxn
const NAMO_TXN_API = process.env.REACT_APP_NAMO_TXN_API;
// .env  ->  REACT_APP_SAVE_HOTEL_TXN_API=https://api.hotel.namantechnolab.com/api/Static/SaveHotelTransaction
const SAVE_HOTEL_TXN_API = process.env.REACT_APP_SAVE_HOTEL_TXN_API;
// .env  ->  REACT_APP_UPDATE_GATEWAY_RQ_API=https://promo.namantechnolab.com/api/Accounts/UpdateGatewayRQ
const UPDATE_GATEWAY_RQ_API = process.env.REACT_APP_UPDATE_GATEWAY_RQ_API;
// .env  ->  REACT_APP_UPDATE_GATEWAY_RS_API=https://promo.namantechnolab.com/api/Accounts/UpdateGatewayRS
const UPDATE_GATEWAY_RS_API = process.env.REACT_APP_UPDATE_GATEWAY_RS_API;
// .env  ->  REACT_APP_USER_SIGNUP_API=https://api.livev1.fly24hrs.com/api/Accounts/UserAdd
const USER_SIGNUP_API = process.env.REACT_APP_USER_SIGNUP_API;
// .env  ->  REACT_APP_CREATE_RAZORPAY_ORDER_API=<create-razorpay-order ka URL>
const CREATE_RAZORPAY_ORDER_API = process.env.REACT_APP_CREATE_RAZORPAY_ORDER_API;
// .env  ->  REACT_APP_VERIFY_RAZORPAY_PAYMENT_API=<verify-razorpay-payment ka URL>
const VERIFY_RAZORPAY_PAYMENT_API = process.env.REACT_APP_VERIFY_RAZORPAY_PAYMENT_API;
// .env  ->  REACT_APP_RAZORPAY_SCRIPT_URL=https://checkout.razorpay.com/v1/checkout.js
const RAZORPAY_SCRIPT_URL = process.env.REACT_APP_RAZORPAY_SCRIPT_URL;
const NAMO_AGENCY_KEY = "02AD68F3-9AE6-4148-85B1-E61D1F03991F";
const NAMO_ACCOUNT_NO = 11;
const AUTO_SIGNUP_PASSWORD = "123456";
const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

// ---------------------------------------------------------------------------
// Razorpay helpers (SaveHotelTransaction ke baad payment gateway kholne ke liye)
// ---------------------------------------------------------------------------
const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = RAZORPAY_SCRIPT_URL;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

const openRazorpayCheckout = ({ amount, bookingId, userKey, guest }) =>
  new Promise(async (resolve, reject) => {
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      reject(new Error("Could not load Razorpay checkout script. Check your internet connection."));
      return;
    }

    let orderData;
    try {
      const orderRes = await fetch(CREATE_RAZORPAY_ORDER_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount,
          currency: "INR",
          receipt: `booking_${bookingId}`,
          notes: { bookingId: String(bookingId), userKey: userKey || "" },
        }),
      });
      orderData = await orderRes.json();
    } catch (err) {
      reject(new Error("Could not reach payment server. Please try again."));
      return;
    }

    if (!orderData?.orderId) {
      reject(new Error(orderData?.error || "Could not initiate payment. Please try again."));
      return;
    }

    const options = {
      key: orderData.keyId,
      amount: orderData.amount,
      currency: orderData.currency,
      name: "TripCaliber",
      description: "Hotel Booking Payment",
      order_id: orderData.orderId,
      prefill: {
        name: `${guest.firstName || "Customer"} ${guest.lastName || ""}`.trim(),
        email: guest.email || "",
        contact: guest.mobile || "",
      },
      notes: { bookingId: String(bookingId) },
      theme: { color: "#1a73e8" },
      handler: async function (response) {
        try {
          const verifyRes = await fetch(VERIFY_RAZORPAY_PAYMENT_API, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            }),
          });
          const verifyData = await verifyRes.json();

          if (verifyData?.success) {
            resolve({
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
            });
          } else {
            reject(new Error("Payment verification failed. If amount was deducted, please contact support."));
          }
        } catch (err) {
          reject(new Error("Something went wrong verifying your payment."));
        }
      },
      modal: {
        ondismiss: function () {
          reject(new Error("__DISMISSED__")); // user ne popup band kiya
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", function (response) {
      reject(new Error("Payment failed: " + (response.error?.description || "Please try again.")));
    });
    rzp.open();
  });

// ---------------------------------------------------------------------------
// Small inline icons
// ---------------------------------------------------------------------------
const IconPin = (props) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <path d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22Z" />
    <circle cx="12" cy="9.5" r="2.4" />
  </svg>
);
const IconUser = (props) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M5 20c1.2-3.6 4-5.4 7-5.4s5.8 1.8 7 5.4" />
  </svg>
);
const IconMeal = (props) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <path d="M6 3v7a2 2 0 0 0 4 0V3M8 10v11M18 3c-1.7 0-3 2-3 5s1.3 5 3 5M18 3v18" />
  </svg>
);
const IconCheck = (props) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export default function HotelReview({ setUserSession, userSession }) {
  const navigate = useNavigate();
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const hasFetched = useRef(false);

  const [guest, setGuest] = useState({
    title: "Mr",
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+91",
    mobile: "",
    gstEnabled: false,
    gstNumber: "",
    billingAddress: "",
    pincode: "",
    state: "Uttar Pradesh",
  });

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchHotelReview();
  }, []);

  const fetchHotelReview = async () => {
    setLoading(true);
    setError(null);

    let searchResponse = null;
    let selectedHotel = null;
    let selectedRoom = null;

    try {
      searchResponse = JSON.parse(sessionStorage.getItem("hotelSearchResponse") || "null");
    } catch (err) {
      console.error("Could not parse hotel search response", err);
    }
    try {
      selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel") || "null");
    } catch (err) {
      console.error("Could not parse selected hotel", err);
    }
    try {
      selectedRoom = JSON.parse(sessionStorage.getItem("selectedRoomOption") || "null");
    } catch (err) {
      console.error("Could not parse selected room option", err);
    }

    if (!searchResponse || !selectedHotel) {
      setError("Hotel search data not found. Please go back and search again.");
      setLoading(false);
      return;
    }
    if (!selectedRoom) {
      setError("No room was selected. Please go back and choose a room first.");
      setLoading(false);
      return;
    }

    const payload = {
      HotelId: String(selectedHotel.TripId || selectedHotel.HotelId || ""),
      optionId: String(selectedRoom?.optionsId || selectedRoom?.optionsid || selectedRoom?.BookHash || ""),
      HotelSearchres: searchResponse,
    };

    if (!HOTEL_REVIEW_API) {
      setError("Hotel review API URL is not configured (REACT_APP_HOTEL_REVIEW_API).");
      setLoading(false);
      return;
    }

    console.log("Hotel review URL:", HOTEL_REVIEW_API);
    console.log("Hotel review request payload:", payload);

    try {
      const res = await fetch(HOTEL_REVIEW_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(`Request failed with status ${res.status}: ${errBody}`);
      }
      const data = await res.json();
      console.log("Hotel review response:", data);
      setReviewData(data);
    } catch (err) {
      console.error("Hotel review request failed:", err);
      setError(err.message || "Something went wrong while fetching hotel review.");
    } finally {
      setLoading(false);
    }
  };

  const updateGuest = (field, value) => setGuest((prev) => ({ ...prev, [field]: value }));

  if (loading) {
    return (
      <>
        <GlobalStyle />
        <div className="hd-center">
          <div className="hd-spinner" />
          <p className="hd-muted">Fetching your room details…</p>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <GlobalStyle />
        <div className="hd-center">
          <p className="hd-error">{error}</p>
        </div>
      </>
    );
  }

  if (!reviewData) {
    return (
      <>
        <GlobalStyle />
        <div className="hd-center">
          <p className="hd-muted">No data received.</p>
        </div>
      </>
    );
  }

  const room = Array.isArray(reviewData.HotelRooms) && reviewData.HotelRooms.length > 0 ? reviewData.HotelRooms[0] : null;
  const basePrice = Number(room?.totalPrice || 0);
  const taxesAndFees = 0; // API doesn't send a separate breakup yet; totalPrice is treated as final for now
  const totalAmount = basePrice + taxesAndFees;

  let searchPayload = null;
  try {
    searchPayload = JSON.parse(sessionStorage.getItem("hotelSearchPayload") || "null");
  } catch (err) {
    console.error("Could not parse hotel search payload", err);
  }

  const checkIn = searchPayload?.CheckIn || "—";
  const checkOut = searchPayload?.CheckOut || "—";
  const nights = Number(searchPayload?.Night || 1);
  const adults = room?.Adults || searchPayload?.Numofadults || "—";

  const address = [reviewData.HotelAddress, reviewData.CityName, reviewData.StateName, reviewData.CountryName]
    .filter(Boolean)
    .join(", ");

  // Try, in order: this room's own images -> hotel images from the review
  // response -> images from the earlier DetailSearch response -> monogram fallback.
  let detailsResponse = null;
  try {
    detailsResponse = JSON.parse(sessionStorage.getItem("hotelDetailsResponse") || "null");
  } catch (err) {
    console.error("Could not parse stored hotel details response", err);
  }

  const heroImage =
    room?.RommImages?.[0] ||
    (Array.isArray(reviewData.Images) ? reviewData.Images[0] : null) ||
    detailsResponse?.HotelRooms?.[0]?.RommImages?.[0] ||
    (Array.isArray(detailsResponse?.Images) ? detailsResponse.Images[0] : null) ||
    null;

  if (!heroImage) {
    console.log("No image found in Review response or stored DetailSearch response — showing monogram fallback.");
  }
  const initials = (reviewData.hotelname || "H").trim().charAt(0).toUpperCase();
  const formatINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

 // Logged-in user ki UserKey (agar login hai)
const getLoggedInUserKey = () => {
  if (!userSession) return null;
  const key =
    userSession?.UserKey ??
    userSession?.userKey ??
    userSession?.Data?.UserKey ??
    userSession?.data?.UserKey ??
    localStorage.getItem("userKey");
  return key && key !== EMPTY_GUID ? String(key) : null;
};
  const handleBookNow = async () => {
    if (submitting) return;
    setSubmitError(null);
const loggedInUserKey = getLoggedInUserKey();

    const missingEnv = [
      ["REACT_APP_NAMO_TXN_API", NAMO_TXN_API],
  ...(loggedInUserKey ? [] : [["REACT_APP_USER_SIGNUP_API", USER_SIGNUP_API]]),
      ["REACT_APP_UPDATE_GATEWAY_RQ_API", UPDATE_GATEWAY_RQ_API],
      ["REACT_APP_UPDATE_GATEWAY_RS_API", UPDATE_GATEWAY_RS_API],
      ["REACT_APP_SAVE_HOTEL_TXN_API", SAVE_HOTEL_TXN_API],
      ["REACT_APP_CREATE_RAZORPAY_ORDER_API", CREATE_RAZORPAY_ORDER_API],
      ["REACT_APP_VERIFY_RAZORPAY_PAYMENT_API", VERIFY_RAZORPAY_PAYMENT_API],
      ["REACT_APP_RAZORPAY_SCRIPT_URL", RAZORPAY_SCRIPT_URL],
    ]
      .filter(([, value]) => !value)
      .map(([name]) => name);
    if (missingEnv.length > 0) {
      console.error("Missing .env variables:", missingEnv.join(", "));
      setSubmitError("Payment is not configured. Missing: " + missingEnv.join(", "));
      return;
    }
    if (!guest.firstName.trim() || !guest.lastName.trim()) {
      setSubmitError("Please enter the guest's first and last name.");
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(guest.email.trim())) {
      setSubmitError("Please enter a valid email address.");
      return;
    }
    if (!/^\d{10}$/.test(guest.mobile.trim())) {
      setSubmitError("Please enter a 10-digit mobile number.");
      return;
    }

    const namoPayload = {
      TransactionId: 0,
      APIRequestType: 9,
      TxnId: null,
      TxnAmount: totalAmount,
      AgencyKey: NAMO_AGENCY_KEY,
      IsGenerated: false,
      IsAssigned: false,
      EmailId: guest.email.trim(),
      BookingType: null,
      PortalId: 11,
      TransactionType: 0,
    };

    setSubmitting(true);
    try {
      console.log("NamoTxn request:", namoPayload);
      const res = await fetch(NAMO_TXN_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(namoPayload),
      });
      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(`NamoTxn failed (${res.status}): ${errBody}`);
      }
      const data = await res.json();
      console.log("NamoTxn response:", data);

      const namoTxnId = data?.TransactionId ?? data?.TxnId ?? data?.NamoTxnId ?? data?.data?.TransactionId ?? null;
      if (!namoTxnId) {
        throw new Error("NamoTxn response mein transaction id nahi mila.");
      }

      sessionStorage.setItem("namoTxnId", String(namoTxnId));
      sessionStorage.setItem("guestDetails", JSON.stringify(guest));

    // ---- UserKey: login hai to wahi, warna auto signup ----
let userKey = loggedInUserKey;
let signupData = null;

if (userKey) {
  console.log("Logged-in user ki UserKey use ho rahi hai, signup skip.");
} else {
  const signupPayload = {
    UserEmail: guest.email.trim(),
    UserName: `${guest.firstName.trim()}${guest.lastName.trim()}`,
    UserMobile: guest.mobile.trim(),
    UserPassword: AUTO_SIGNUP_PASSWORD,
    AgencyKey: NAMO_AGENCY_KEY,
    AccountNo: NAMO_ACCOUNT_NO,
  };

  console.log("SIGNUP URL:", USER_SIGNUP_API);
  console.log("User signup request:", { ...signupPayload, UserPassword: "******" });
  const signupRes = await fetch(USER_SIGNUP_API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(signupPayload),
  });
  const signupText = await signupRes.text();
  try {
    signupData = JSON.parse(signupText);
  } catch (e) {
    signupData = null;
  }
  console.log("User signup response:", signupRes.status, signupData ?? signupText);

  userKey =
    signupData?.UserKey ?? signupData?.userKey ?? signupData?.Data?.UserKey ?? signupData?.data?.UserKey ?? null;

  if (!signupRes.ok || !userKey || userKey === EMPTY_GUID) {
    throw new Error(
      signupData?.Error?.ErrorDesc ||
        signupData?.message ||
        "User signup failed: valid UserKey not received. Check signup API URL / response."
    );
  }
}
sessionStorage.setItem("userKey", String(userKey));

      // ---- Signup ke baad: UpdateGatewayRQ ----
      const finalAmount = Number(Number(totalAmount).toFixed(2));

      const gatewayPaymentRequest = {
        GatewayPrice: 0.0,
        Error: null,
        GatewayStatus: null,
        GatewayKey: "RAZORPAY",
        GatewayOrderId: null,
        UserKey: String(userKey),
        BookingId: String(namoTxnId),
        PaxFirstName: guest.firstName.trim() || "Customer",
        PaxLastName: guest.lastName.trim() || "",
        PaxEmailId: guest.email.trim() || "noreply@example.com",
        PaxMobileNo: guest.mobile.trim() || null,
        Amount: finalAmount.toFixed(2),
        ProductInfo: "Hotel",
        Surl: `${window.location.origin}/payment-success?bookingId=${namoTxnId}`,
        Furl: `${window.location.origin}/payment-failure?bookingId=${namoTxnId}`,
        Hash: null,
        BookingKey: "",
        udf1: String(userKey),
        udf2: "",
      };

      const updateGatewayPayload = {
        TransactionId: Number(namoTxnId),
        Price: finalAmount,
        GatewayCharge: 0,
        PaymentRequest: JSON.stringify(gatewayPaymentRequest),
        OrderId: String(namoTxnId),
        UserKey: String(userKey),
        ProcessType: 2,
        BookingType: 0,
        AgencyKey: NAMO_AGENCY_KEY,
        AccountNo: NAMO_ACCOUNT_NO,
      };

      console.log("UpdateGatewayRQ request:", updateGatewayPayload);
      const gwRes = await fetch(UPDATE_GATEWAY_RQ_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updateGatewayPayload),
      });
      const gwData = await gwRes.json();
      console.log("UpdateGatewayRQ response:", gwData);

      const gwHasError = gwData?.Error?.ErrorCode || gwData?.Error?.ErrorDesc;
      if (!gwRes.ok || gwHasError || gwData?.GatewayStatus !== "Proceed") {
        throw new Error(gwData?.Error?.ErrorDesc || "UpdateGatewayRQ failed. Please try again.");
      }

      let selectedHotel = null;
      try {
        selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel") || "null");
      } catch (err) {
        console.error("Could not parse selected hotel", err);
      }

      const txnIdValue = Number.isNaN(Number(namoTxnId)) ? namoTxnId : Number(namoTxnId);

      const savePayload = {
        TransactionId: txnIdValue,
        NamoTxnId: txnIdValue,
         UserKey: String(userKey),
        HotelSerchRQ: {
          EngineId: Number(searchPayload?.EngineId ?? reviewData?.EngineId ?? selectedHotel?.EngineId ?? 0),
        },
        BookingRQ: {
          bookingId: String(reviewData?.bookingId ?? reviewData?.BookingId ?? ""),
        },
        CheckInDate: searchPayload?.CheckIn || null,
        CheckOutDate: searchPayload?.CheckOut || null,
        HotelReviewRS: {
          hotelname: reviewData.hotelname || "",
          HotelAddress: reviewData.HotelAddress || "",
          CityName: reviewData.CityName || "",
          StateName: reviewData.StateName || "",
          CountryName: reviewData.CountryName || "",
          Totaladults: Number(room?.Adults || searchPayload?.Numofadults || 1),
          TotalChild: Number(searchPayload?.Numofchild ?? searchPayload?.NumofChild ?? 0),
          Totalroom: Number(searchPayload?.Numofrooms ?? searchPayload?.NumofRooms ?? 1),
          Passengerdetails: [
            {
              FirstName: [guest.firstName.trim()],
              LastName: [guest.lastName.trim()],
              Email: [guest.email.trim()],
              ContactNumber: [guest.mobile.trim()],
              Address: guest.gstEnabled ? guest.billingAddress : "",
              Pincode: guest.gstEnabled ? guest.pincode : "",
              GSTIN: guest.gstEnabled ? guest.gstNumber.trim() : "",
            },
          ],
          HotelRooms: [
            {
              RoomType: room?.RoomType || "",
              totalPrice: String(room?.totalPrice ?? totalAmount),
            },
          ],
        },
      };

      console.log("SaveHotelTransaction request:", savePayload);
      const saveRes = await fetch(SAVE_HOTEL_TXN_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(savePayload),
      });
      const saveBody = await saveRes.text();
      console.log("SaveHotelTransaction response:", saveRes.status, saveBody);
      if (!saveRes.ok) {
        throw new Error(`SaveHotelTransaction failed (${saveRes.status}): ${saveBody}`);
      }

      // ---- SaveHotelTransaction ke baad: Razorpay payment gateway ----
      let payResult;
      try {
        payResult = await openRazorpayCheckout({
          amount: finalAmount,
          bookingId: namoTxnId,
          userKey: String(userKey),
          guest,
        });
      } catch (payErr) {
        if (payErr.message === "__DISMISSED__") {
          setSubmitError("Payment cancelled. Click 'Book now' to try again.");
          return;
        }
        alert(payErr.message || "Payment could not be completed.");
        navigate(`/payment-failure?bookingId=${namoTxnId}`);
        return;
      }

      // Payment hui aur server par verify bhi ho gayi
      sessionStorage.setItem("lastBookingId", String(namoTxnId));
      sessionStorage.setItem("lastUserKey", String(userKey));
      sessionStorage.setItem("lastAmount", String(finalAmount));
      sessionStorage.setItem("lastAmountCurrency", "INR");
      sessionStorage.setItem("lastPaymentId", payResult.paymentId);
      sessionStorage.setItem("lastRazorpayOrderId", payResult.orderId);

      // Hotel ticket page (/hotel-ticket) aur PaymentSuccess redirect ke liye
      sessionStorage.setItem("hotelReviewData", JSON.stringify(reviewData));
      sessionStorage.setItem("hotelBookingId", String(namoTxnId));
// Auto-login: payment verify ho chuki hai, ab user panel me login kar do
if (!userSession) {
  try {
    const userData = { ...(signupData || {}), UserKey: String(userKey) };
    localStorage.setItem("userData", JSON.stringify(userData));
    localStorage.setItem("userKey", String(userKey));
    setUserSession?.(userData);
  } catch (e) {
    console.error("Auto-login failed:", e);
  }
}
      // ---- Payment ke baad: UpdateGatewayRS ----
      const gatewayResponseObj = {
        mihpayid: payResult.paymentId,
        razorpay_payment_id: payResult.paymentId,
        razorpay_order_id: payResult.orderId,
        status: "success",
      };

      const updateGatewayRSPayload = {
        BookingId: null,
        TransactionId: Number(namoTxnId),
        RecAmount: finalAmount,
        Currency: "INR",
        GatewayResponse: JSON.stringify(gatewayResponseObj),
        GatewayStatus: 1,
        UserKey: String(userKey),
        IsTC: true,
        IsB2B: false,
        AccountNo: NAMO_ACCOUNT_NO,
        AgencyKey: NAMO_AGENCY_KEY,
      };

      console.log("UpdateGatewayRS request:", updateGatewayRSPayload);
      try {
        const rsRes = await fetch(UPDATE_GATEWAY_RS_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updateGatewayRSPayload),
        });
        const rsData = await rsRes.json().catch(() => null);
        console.log("UpdateGatewayRS response:", rsRes.status, rsData);

        const rsHasError = rsData?.Error?.ErrorCode || rsData?.Error?.ErrorDesc;
        if (!rsRes.ok || rsHasError) {
          throw new Error(rsData?.Error?.ErrorDesc || `HTTP ${rsRes.status}`);
        }
      } catch (rsErr) {
        console.error("UpdateGatewayRS failed:", rsErr);
        throw new Error(
          `Payment received (Payment ID: ${payResult.paymentId}) but we could not confirm your booking. ` +
            `Please do not pay again. Contact support with Booking ID ${namoTxnId}.`
        );
      }

      navigate(`/payment-success?bookingId=${namoTxnId}`);
    } catch (err) {
      console.error("Book now flow failed:", err);
      setSubmitError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <GlobalStyle />
      <div className="hd-page">
        <div className="hd-shell">
          {/* Step progress */}
          <ol className="hd-steps">
            <li className="hd-step hd-step--done">
              <span className="hd-step-mark"><IconCheck /></span>
              Room
            </li>
            <li className="hd-step hd-step--current">
              <span className="hd-step-mark">2</span>
              Guest details
            </li>
            <li className="hd-step hd-step--upcoming">
              <span className="hd-step-mark">3</span>
              Payment
            </li>
          </ol>

          <div className="hd-grid">
            {/* ---------------- Left column ---------------- */}
            <div className="hd-main">
              {/* Hero property card */}
              <section className="hd-hero">
                <div className="hd-hero-media">
                  {heroImage ? (
                    <img src={heroImage} alt={reviewData.hotelname} />
                  ) : (
                    <div className="hd-hero-fallback">{initials}</div>
                  )}
                  <div className="hd-hero-scrim" />
                  <div className="hd-hero-caption">
                    <span className="hd-hero-rating">
                      {"★".repeat(Math.max(0, Math.min(5, Number(reviewData.HotelRating) || 0)))}
                    </span>
                    <h1 className="hd-hero-name">{reviewData.hotelname}</h1>
                    <p className="hd-hero-address">
                      <IconPin className="hd-icon" /> {address || "Address not available"}
                    </p>
                  </div>
                </div>

                <div className="hd-stay-row">
                  <div className="hd-stay-item">
                    <span className="hd-stay-label">Check-in</span>
                    <span className="hd-stay-value">{checkIn}</span>
                  </div>
                  <div className="hd-stay-divider" />
                  <div className="hd-stay-item">
                    <span className="hd-stay-label">Check-out</span>
                    <span className="hd-stay-value">{checkOut}</span>
                  </div>
                  <div className="hd-stay-divider" />
                  <div className="hd-stay-item">
                    <span className="hd-stay-label">{nights} night{nights > 1 ? "s" : ""}</span>
                    <span className="hd-stay-value">{adults} adult{Number(adults) > 1 ? "s" : ""}</span>
                  </div>
                </div>

                {room && (
                  <div className="hd-room">
                    <span className="hd-room-label">Room selected</span>
                    <h2 className="hd-room-name">{room.RoomType}</h2>
                    <div className="hd-room-meta">
                      <span><IconUser className="hd-icon" /> {room.Adults} adult{Number(room.Adults) > 1 ? "s" : ""}</span>
                      <span><IconMeal className="hd-icon" /> {room.Mealbasis}</span>
                    </div>
                  </div>
                )}
              </section>

              {/* Guest details */}
              <section className="hd-section">
                <h3 className="hd-section-title">Who's staying</h3>
                <p className="hd-section-sub">Your booking voucher and confirmation go to these details.</p>

                <div className="hd-form-row">
                  <div className="hd-field" style={{ maxWidth: 96 }}>
                    <label>Title</label>
                    <select value={guest.title} onChange={(e) => updateGuest("title", e.target.value)}>
                      <option>Mr</option>
                      <option>Mrs</option>
                      <option>Ms</option>
                    </select>
                  </div>
                  <div className="hd-field">
                    <label>First name</label>
                    <input
                      placeholder="e.g. Aarav"
                      value={guest.firstName}
                      onChange={(e) => updateGuest("firstName", e.target.value)}
                    />
                  </div>
                  <div className="hd-field">
                    <label>Last name</label>
                    <input
                      placeholder="e.g. Sharma"
                      value={guest.lastName}
                      onChange={(e) => updateGuest("lastName", e.target.value)}
                    />
                  </div>
                </div>

                <div className="hd-form-row">
                  <div className="hd-field">
                    <label>Email address</label>
                    <input
                      type="email"
                      placeholder="you@example.com"
                      value={guest.email}
                      onChange={(e) => updateGuest("email", e.target.value)}
                    />
                  </div>
                  <div className="hd-field">
                    <label>Mobile number</label>
                    <div className="hd-phone">
                      <select value={guest.countryCode} onChange={(e) => updateGuest("countryCode", e.target.value)}>
                        <option value="+91">+91</option>
                      </select>
                      <input
                        placeholder="10-digit number"
                        value={guest.mobile}
                        onChange={(e) => updateGuest("mobile", e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <label className="hd-checkbox">
                  <input
                    type="checkbox"
                    checked={guest.gstEnabled}
                    onChange={(e) => updateGuest("gstEnabled", e.target.checked)}
                  />
                  Add GST details for a business invoice
                </label>

                {guest.gstEnabled && (
                  <div className="hd-form-row hd-form-row--tight">
                    <div className="hd-field">
                      <label>GST number</label>
                      <input
                        placeholder="09ABCDE1234F1Z5"
                        value={guest.gstNumber}
                        onChange={(e) => updateGuest("gstNumber", e.target.value.toUpperCase())}
                      />
                    </div>
                    <div className="hd-field">
                      <label>Billing address</label>
                      <input
                        placeholder="Street, area"
                        value={guest.billingAddress}
                        onChange={(e) => updateGuest("billingAddress", e.target.value)}
                      />
                    </div>
                    <div className="hd-field" style={{ maxWidth: 140 }}>
                      <label>Pincode</label>
                      <input
                        placeholder="302017"
                        value={guest.pincode}
                        onChange={(e) => updateGuest("pincode", e.target.value)}
                      />
                    </div>
                    <div className="hd-field" style={{ maxWidth: 200 }}>
                      <label>State</label>
                      <select value={guest.state} onChange={(e) => updateGuest("state", e.target.value)}>
                        <option>Uttar Pradesh</option>
                        <option>Rajasthan</option>
                        <option>Maharashtra</option>
                        <option>Delhi</option>
                      </select>
                    </div>
                  </div>
                )}
              </section>
            </div>

            {/* ---------------- Right column ---------------- */}
            <aside className="hd-summary">
              <div className="hd-summary-card">
                <h3 className="hd-summary-title">Price summary</h3>

                <div className="hd-price-row">
                  <span>Room · {nights} night{nights > 1 ? "s" : ""}</span>
                  <span>{formatINR(basePrice)}</span>
                </div>
                <div className="hd-price-row">
                  <span>Taxes &amp; fees</span>
                  <span>{formatINR(taxesAndFees)}</span>
                </div>

                <div className="hd-summary-rule" />

                <div className="hd-price-total">
                  <span>Total payable</span>
                  <span>{formatINR(totalAmount)}</span>
                </div>
                <p className="hd-summary-note">Includes taxes and fees</p>

                <button className="hd-cta" onClick={handleBookNow} disabled={submitting}>
                  {submitting ? "Please wait…" : "Book now"}
                </button>

                {submitError && <p className="hd-submit-error">{submitError}</p>}

                <p className="hd-summary-fine">You won't be charged yet</p>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
}

// ---------------------------------------------------------------------------
// Styles — scoped under .hd-*
// ---------------------------------------------------------------------------
function GlobalStyle() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Inter:wght@400;500;600;700&display=swap');

      .hd-page, .hd-page *, .hd-page *::before, .hd-page *::after { box-sizing: border-box; }

      .hd-page {
        --ink: #16215C;
        --ink-soft: #26389E;
        --accent: #E4127F;
        --accent-deep: #B80E64;
        --paper: #F4F6FB;
        --card: #FFFFFF;
        --line: #E1E5F2;
        --text: #1A1F36;
        --text-soft: #667085;
        --danger: #B3261E;

        background: var(--paper);
        min-height: 100vh;
        padding: 40px 20px 80px;
        font-family: 'Inter', sans-serif;
        color: var(--text);
        overflow-x: hidden;
        -webkit-tap-highlight-color: transparent;
      }

      .hd-center {
        min-height: 60vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 20px;
        text-align: center;
        font-family: 'Inter', sans-serif;
      }
      .hd-muted { color: #756F63; }
      .hd-error { color: #B3261E; font-weight: 600; overflow-wrap: anywhere; max-width: 560px; }
      .hd-spinner {
        width: 28px; height: 28px; border-radius: 50%;
        border: 3px solid #E1E5F2; border-top-color: #E4127F;
        animation: hd-spin 0.8s linear infinite;
      }
      @keyframes hd-spin { to { transform: rotate(360deg); } }

      .hd-shell { max-width: 1080px; margin: 0 auto; }

      /* Steps */
      .hd-steps {
        display: flex; align-items: center; gap: 10px;
        list-style: none; padding: 0; margin: 0 0 28px;
        font-size: 13px; color: var(--text-soft);
      }
      .hd-step { display: flex; align-items: center; gap: 8px; }
      .hd-step:not(:last-child)::after {
        content: ""; width: 28px; height: 1px; background: var(--line); margin-left: 10px;
      }
      .hd-step-mark {
        width: 20px; height: 20px; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        font-size: 11px; border: 1px solid var(--line); color: var(--text-soft);
        flex-shrink: 0;
      }
      .hd-step--done .hd-step-mark { background: linear-gradient(90deg, #0d2b6b 0%, #1a4fa0 55%, #2a63c4 100%); border-color: var(--ink); color: #fff; }
      .hd-step--done { color: var(--ink); }
      .hd-step--current .hd-step-mark { border-color: var(--accent); color: var(--accent-deep); font-weight: 600; }
      .hd-step--current { color: var(--text); font-weight: 600; }

      /* Grid */
      .hd-grid { display: grid; grid-template-columns: 1.7fr 1fr; gap: 24px; align-items: start; }

      .hd-main { display: flex; flex-direction: column; gap: 20px; min-width: 0; }

      /* Hero */
      .hd-hero {
        background: var(--card);
        border: 1px solid var(--line);
        border-radius: 14px;
        overflow: hidden;
      }
      .hd-hero-media { position: relative; height: 230px; }
      .hd-hero-media img { width: 100%; height: 100%; object-fit: cover; display: block; }
      .hd-hero-fallback {
        width: 100%; height: 100%;
        display: flex; align-items: center; justify-content: center;
        background: linear-gradient(135deg, var(--ink), var(--ink-soft));
        color: var(--accent); font-family: 'Fraunces', serif; font-size: 64px; font-weight: 500;
      }
      .hd-hero-scrim {
        position: absolute; inset: 0;
        background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(10,20,16,0.82) 100%);
      }
      .hd-hero-caption { position: absolute; left: 20px; right: 20px; bottom: 16px; color: #fff; }
      .hd-hero-rating { color: var(--accent); font-size: 13px; letter-spacing: 1px; }
      .hd-hero-name {
        font-family: 'Fraunces', serif; font-weight: 600; font-size: 26px;
        margin: 2px 0 6px; line-height: 1.15; overflow-wrap: anywhere;
      }
      .hd-hero-address {
        display: flex; align-items: flex-start; gap: 6px;
        font-size: 13px; color: rgba(255,255,255,0.88); margin: 0;
        line-height: 1.4;
      }
      .hd-hero-address .hd-icon { margin-top: 2px; }
      .hd-icon { flex-shrink: 0; opacity: 0.8; }

      .hd-stay-row {
        display: flex; align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid var(--line);
      }
      .hd-stay-item { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
      .hd-stay-label { font-size: 11px; color: var(--text-soft); }
      .hd-stay-value { font-size: 14px; font-weight: 600; }
      .hd-stay-divider { width: 1px; height: 28px; background: var(--line); margin: 0 22px; flex-shrink: 0; }

      .hd-room { padding: 18px 20px 22px; }
      .hd-room-label { font-size: 12px; color: var(--text-soft); }
      .hd-room-name {
        font-family: 'Fraunces', serif; font-weight: 600; font-size: 19px;
        margin: 4px 0 8px; overflow-wrap: anywhere;
      }
      .hd-room-meta { display: flex; flex-wrap: wrap; gap: 8px 18px; font-size: 13px; color: var(--text-soft); }
      .hd-room-meta span { display: flex; align-items: center; gap: 6px; }

      /* Section (guest details) */
      .hd-section {
        background: var(--card);
        border: 1px solid var(--line);
        border-radius: 14px;
        padding: 24px 24px 28px;
      }
      .hd-section-title { font-family: 'Fraunces', serif; font-size: 20px; font-weight: 600; margin: 0 0 4px; }
      .hd-section-sub { font-size: 13px; color: var(--text-soft); margin: 0 0 20px; }

      .hd-form-row { display: flex; gap: 18px; margin-bottom: 18px; }
      .hd-form-row--tight { margin-top: -4px; }

      .hd-field { flex: 1; display: flex; flex-direction: column; gap: 6px; min-width: 0; }
      .hd-field label { font-size: 12px; color: var(--text-soft); }
      .hd-field input, .hd-field select {
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        padding: 8px 2px;
        border: none;
        border-bottom: 1.5px solid var(--line);
        background: transparent;
        color: var(--text);
        outline: none;
        border-radius: 0;
        transition: border-color 0.15s ease;
        width: 100%;
        min-width: 0;
      }
      .hd-field input::placeholder { color: #B7B0A2; }
      .hd-field input:focus, .hd-field select:focus { border-bottom-color: var(--accent); }

      .hd-phone { display: flex; gap: 10px; }
      .hd-phone select { width: 62px; flex-shrink: 0; }
      .hd-phone input { flex: 1; min-width: 0; }

      .hd-checkbox {
        display: flex; align-items: center; gap: 9px;
        font-size: 13.5px; color: var(--text);
        margin-top: 4px; cursor: pointer;
      }
      .hd-checkbox input { accent-color: var(--accent); width: 15px; height: 15px; flex-shrink: 0; }

      /* Price summary */
      .hd-summary { position: sticky; top: 24px; min-width: 0; }

      .hd-summary-card {
        background: #ffffff;
        color: #000000;
        border-radius: 14px;
        padding: 24px;
      }
      .hd-summary-title { font-family: 'Fraunces', serif; font-size: 18px; font-weight: 600; margin: 0 0 16px; }

      .hd-price-row {
        display: flex; justify-content: space-between; gap: 12px;
        font-size: 13.5px;
        color: #000000;
        margin-bottom: 10px;
      }

      .hd-summary-rule { height: 1px; background: rgba(242,239,230,0.18); margin: 14px 0; }

      .hd-price-total {
        display: flex; justify-content: space-between; align-items: baseline;
        font-family: 'Fraunces', serif; font-size: 22px; font-weight: 600;
        color:#ea580c;
      }
      .hd-summary-note { font-size: 11.5px; color: #000000; margin: 4px 0 0; }

      .hd-cta {
        width: 100%; margin-top: 20px;
        background: #ea580c;
        color: #FFFFFF;
        border: none; border-radius: 8px;
        padding: 13px 0;
        font-size: 14.5px; font-weight: 700;
        font-family: 'Inter', sans-serif;
        cursor: pointer;
        transition: background 0.15s ease;
      }
      .hd-cta:hover { background: var(--accent-deep); }
      .hd-cta:disabled { opacity: 0.6; cursor: not-allowed; }

      .hd-submit-error { color: var(--danger); font-size: 13px; font-weight: 600; margin: 10px 0 0; overflow-wrap: anywhere; line-height: 1.4; }

      .hd-summary-fine { text-align: center; font-size: 11.5px; color: #000000; margin: 10px 0 0; }

      /* ================= Responsive ================= */

      /* Tablet & below: single column */
      @media (max-width: 900px) {
        .hd-page { padding: 28px 16px 60px; }
        .hd-grid { grid-template-columns: 1fr; gap: 16px; }
        .hd-summary { position: static; }
        .hd-summary-card { border: 1px solid var(--line); }

        /* GST row: let the 4 fields wrap instead of squeezing */
        .hd-form-row--tight { flex-wrap: wrap; }
        .hd-form-row--tight .hd-field { flex: 1 1 calc(50% - 9px); max-width: none !important; }
      }

      /* Phones */
      @media (max-width: 560px) {
        .hd-page { padding: 16px 12px 40px; }

        /* steps */
        .hd-steps { font-size: 12px; gap: 6px; margin-bottom: 16px; }
        .hd-step { gap: 6px; }
        .hd-step:not(:last-child)::after { width: 14px; margin-left: 4px; }

        /* hero */
        .hd-hero { border-radius: 12px; }
        .hd-hero-media { height: 180px; }
        .hd-hero-caption { left: 14px; right: 14px; bottom: 12px; }
        .hd-hero-name { font-size: 20px; }
        .hd-hero-address { font-size: 12px; }

        .hd-stay-row { padding: 14px; }
        .hd-stay-divider { margin: 0 12px; height: 32px; }
        .hd-stay-value { font-size: 13px; }

        .hd-room { padding: 14px 14px 18px; }
        .hd-room-name { font-size: 17px; }

        /* form */
        .hd-section { padding: 18px 14px 22px; border-radius: 12px; }
        .hd-section-title { font-size: 18px; }
        .hd-section-sub { margin-bottom: 16px; }
        .hd-form-row { flex-direction: column; gap: 14px; margin-bottom: 14px; }
        .hd-form-row--tight { flex-wrap: nowrap; margin-top: 0; }
        .hd-form-row--tight .hd-field { flex: 1 1 auto; }
        /* the JSX gives Title / Pincode / State inline max-widths – undo on phones */
        .hd-field { max-width: none !important; }

        /* 16px stops iOS from zooming when an input is focused; taller tap targets */
        .hd-field input, .hd-field select { font-size: 16px; padding: 10px 2px; min-height: 44px; }
        .hd-phone select { width: 74px; }

        .hd-checkbox { font-size: 14px; line-height: 1.4; align-items: flex-start; padding: 6px 0; }
        .hd-checkbox input { width: 20px; height: 20px; margin-top: 1px; }

        /* summary */
        .hd-summary-card { padding: 18px 16px; border-radius: 12px; }
        .hd-price-total { font-size: 20px; }
        .hd-cta { min-height: 52px; font-size: 16px; margin-top: 16px; }
      }

      /* Very small phones */
      @media (max-width: 360px) {
        .hd-stay-divider { margin: 0 8px; }
        .hd-stay-value { font-size: 12.5px; }
        .hd-hero-name { font-size: 18px; }
      }
    `}</style>
  );
}